"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerInput = void 0;
var PlayerInput;
(function (PlayerInput) {
    function getCard(cards, cardName) {
        const idx = cards.findIndex((card) => card.name === cardName);
        if (idx === -1) {
            throw new Error(`Card ${cardName} not found`);
        }
        const card = cards[idx];
        return { card, idx };
    }
    PlayerInput.getCard = getCard;
})(PlayerInput = exports.PlayerInput || (exports.PlayerInput = {}));
//# sourceMappingURL=PlayerInput.js.map